import React from 'react';
import { Divider, Empty } from 'antd';
import CustomScrollbars from 'components/CustomScrollbars';
import NotificationItem from './NotificationItem';

const NotificationList = ({ data, paginationChanged, pagination, fetch }) => {
  const { items = [], loaded, loading } = data;

  const renderDivider = (count, index) => {
    if (count > 1 && index !== count - 1) {
      return <Divider className="gx-mt-1 gx-mb-1" />;
    }

    return null;
  };

  const paginationChangeHandler = () => {
    if (pagination.total > items.length) {
      paginationChanged(pagination.current + 1);
    }
  };

  const handleScrollEnd = () => {
    paginationChangeHandler();
  };

  return (
    <CustomScrollbars
      className="notification-scroll"
      onScrollEnd={handleScrollEnd}
    >
      {items.map((c, index) => (
        <div key={c.id}>
          <NotificationItem key={c.id} item={c} fetch={fetch} />
          {renderDivider(items.length, index)}
        </div>
      ))}
      {loaded && !loading && items.length === 0 && <Empty />}
    </CustomScrollbars>
  );
};

export default NotificationList;
